// Pont natif Capacitor pour le shell mobile Life :
//   - bouton retour matériel Android : ferme la feuille d'ajout si ouverte,
//     sinon revient en arrière, sinon (déjà sur un onglet racine) quitte l'app ;
//   - deep links (appUrlOpen) : https://…/route ou com.lifeapp.mobile://route
//     → navigation interne vers la route correspondante.
// Ne fait rien hors contexte natif (web desktop / responsive).
import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { App as CapacitorApp } from '@capacitor/app'
import { isNativeApp } from 'utils/mobile'

// Onglets racine : un « retour » depuis ces écrans quitte l'app.
const ROOT_PATHS = ['/', '/domaines', '/moncalendrier', '/profil', '/login']

const NativeBridge = ({ addOpen, onCloseAdd }) => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!isNativeApp()) return undefined

    const subs = []

    // Retour matériel Android
    subs.push(
      CapacitorApp.addListener('backButton', () => {
        if (addOpen) {
          onCloseAdd()
          return
        }
        const path = location.pathname.toLowerCase()
        if (ROOT_PATHS.includes(path)) {
          CapacitorApp.exitApp()
        } else {
          navigate(-1)
        }
      }),
    )

    // Deep links — on ne garde que le chemin + la query de l'URL entrante.
    subs.push(
      CapacitorApp.addListener('appUrlOpen', ({ url }) => {
        try {
          const u = new URL(url)
          // https://…/todos?filter=x → /todos?filter=x
          // com.lifeapp.mobile://todos → host porte la route → /todos
          let target =
            u.pathname && u.pathname !== '/' ? `${u.pathname}${u.search}` : ''
          if (!target && u.host) target = `/${u.host}${u.search}`
          navigate(target || '/')
        } catch (_) {
          // URL illisible : on ignore.
        }
      }),
    )

    return () => {
      subs.forEach((p) => p.then((s) => s.remove()).catch(() => {}))
    }
  }, [addOpen, onCloseAdd, location.pathname, navigate])

  return null
}

export default NativeBridge
